import { runInAction } from 'mobx';
import { DataStore } from 'mobx/dataStore';
import { StateStore } from 'mobx/stateStore';
import { UiStore } from 'mobx/uiStore';

export class RootStore {
  // @ts-ignore
  uiStore: UiStore;
  // @ts-ignore
  stateStore: StateStore;
  // @ts-ignore
  dataStore: DataStore;

  constructor() {
    runInAction(() => {
      this.uiStore = new UiStore({ rootStore: this });
      this.stateStore = new StateStore();
      this.dataStore = new DataStore();
    });
  }
}

const rootStore = new RootStore();
export default rootStore;
